// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLocalStorage from 'vue-localstorage'
import VueResource from 'vue-resource'
import { API_HOST } from './services/constant'
import Vue2Filters from 'vue2-filters'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import GeminiScrollbar from 'vue-gemini-scrollbar'
import VueCanvasPoster from 'vue-canvas-poster'
import decimalFormat from './services/toFixed'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'

import VueQuillEditor from 'vue-quill-editor'
import {Quill} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
//import 'faz-quill-emoji/dist/faz.quill.emoji.css'
//import RegisterFazQuillEmoji from "faz-quill-emoji"

Vue.use(ElementUI, {locale})
Vue.use(VueQuillEditor)

//RegisterFazQuillEmoji(Quill)


import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Input,
  Row,
  Col,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Checkbox,
  Select,
  Switch,
  Option,
  OptionGroup,
  Form,
  FormItem,
  Steps,
  Step,
  Dialog,
  Autocomplete,
  Upload,
  Radio,
  RadioGroup,
  RadioButton,
  CheckboxButton,
  CheckboxGroup,
  MessageBox,
  Message,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tabs,
  Table,
  TableColumn,
  TabPane,
  Popover,
  Pagination,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Tooltip,
  Cascader,
  InputNumber,
  DatePicker
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icomoon/style.css'
import 'reset-css'
import './assets/sass/_base.scss'
import './assets/sass/_global.scss'
import './assets/sass/pages/_passport.scss'
import './assets/sass/_mobile.scss'
import './assets/sass/_dropdown.scss'
import './assets/sass/_button.scss'
import './assets/sass/_box.scss'
import './assets/sass/_sprite.scss'
import './assets/sass/_tab.scss'
import './assets/sass/_popover.scss'
import './assets/sass/_pagination.scss'

import './directives/IptFocus'
import './directives/Focus'
import './directives/HeaderSticky'
//import './services/toFixed'
import Loading from '@/components/Loading'
let _ = require('lodash')
//let preRequest=null
Vue.use(GeminiScrollbar)
Vue.use(Button)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Checkbox)
Vue.use(CollapseItem)
Vue.use(Collapse)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(Step)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(Autocomplete)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(VueClipboard)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Cascader)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(VueCanvasPoster)

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$message = Message
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$decimalFormat=decimalFormat

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.http.options.root = `${API_HOST}/api`

Vue.use(Vue2Filters)
Vue.use(require('vue-moment'))

// localStorage
Vue.use(VueLocalStorage)
Vue.component('Loading', Loading)
Vue.http.interceptors.push((request, next) => {
  // if(request.url == 'https://kop.kuaidihelp.com/api'){
  //   console.log(request.url)
  //   request.headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
  // }
  let params = _.chain(window.location.href)
    .replace(/.*\?/, '')
    .split('&')
    .map(_.partial(_.split, _, '=', 2))
    .fromPairs()
    .value()
  let token = Vue.localStorage.get('token') || params.token
  if (token) {
    Vue.localStorage.set('token', token)
  }
  if (token) {
    request.headers.set('token', token)
  /*if(request.params && request.params.api=='mul_upload_picture'){
    request.headers.set('Content-Type','multipart/form-data')
  }*/
    //request.headers.set('Authorization', 'Bearer '+token)
    //request.headers.set('Access-Control-Max-Age', 604800)
  }
  next()
})

Vue.http.interceptors.push((request, next) => {
  /*if(preRequest){
    console.log('abort',preRequest)
    preRequest.abort()
  }
  preRequest=request*/
  next((response) => {
    if([API_HOST+"/api/cart.php?api=recovery",API_HOST+"/api/cart.php?api=update",API_HOST+"/api/cart.php?api=delete",API_HOST+"/api/cart.php?api=add"].indexOf(response.url) >-1 ){
      if(response.body.status == 'ok'){
        store.commit('updateCartCount','cartChangeVisible')
      }
    }
    // if(response.url == API_HOST+"/api/passport.php?api=get_info" && window.location.pathname !== '/'){
    //   if (response.status === 401) {
    //     if (request.params.login_dialog || window.innerWidth <= 768) {
    //       store.commit('showGlobalDialog', 'loginVisible')
    //     } else {
    //       window.location.href = '/login'
    //     }
    //   }
    //   if (response.body.result === 'already_updated') {
    //     MessageBox.alert('订单数据已更新，请先刷新页面', '数据更新', {
    //       confirmButtonText: '确定',
    //       callback: action => {
    //         window.location.reload()
    //       }
    //     })
    //   }
    // }
    if (window.location.pathname === '/' || window.location.pathname === '/MerchantList'|| window.location.pathname.indexOf('/Merchant') > -1 || window.location.pathname.indexOf('/item') > -1 || window.location.pathname.indexOf('/items') > -1 || window.location.pathname.indexOf('/HelpCenter') > -1 || window.location.pathname === '/snatch' || window.location.pathname ==='/Company'
    || window.location.pathname.indexOf('/products')>-1 || window.location.pathname ==='/tracktask') {
      return
    }
    if(window.location.pathname.toLowerCase().indexOf('privacy')>-1 || window.location.pathname.toLowerCase().indexOf('apay')>-1 || window.location.pathname.toLowerCase()=='/taskpay' ||
    window.location.pathname.toLowerCase()==='/qrcode' || window.location.pathname.toLowerCase()==='/search'
    || window.location.pathname.toLowerCase().indexOf('/product/')>-1 || window.location.pathname.toLowerCase().indexOf('/track/')>-1){
      return
    }
    if (response.status === 401) {
      if (request.params.login_dialog || window.innerWidth <= 768) {
        store.commit('showGlobalDialog', 'loginVisible')
      } else {
        window.location.href = '/login'
      }
    }
    /*if (response.body.result === 'already_updated') {
      MessageBox.alert('订单数据已更新，请先刷新页面', '数据更新', {
        confirmButtonText: '确定',
        callback: action => {
          window.location.reload()
        }
      })
    }*/
  })
})

Vue.filter('cardNumberEncrypt', function (value) {
  if (value) {
    let str = String(value)
    return '******' + str.substring(str.length - 4)
  }
})

Vue.filter('dateFilter', function (value) {
  if (value) {
    let day = 24 * 3600 * 1000
    let newDate = new Date(value).setHours(0, 0, 0, 0)
    let currentDate = new Date().setHours(0, 0, 0, 0)
    let days = (currentDate - newDate) / day
    switch (days) {
      case 0:
        return '今天'
      case 1:
        return '昨天'
      default:
        return Vue.moment(value).format('YYYY-MM-DD')
    }
  }
})

Vue.filter('numberFilter', function (value) {
  if (value) {
    let str = String(value)
    if(str.length > 3){
      let checkStr = str.slice(-2)
      if(Number(checkStr)>0){
        let newStr = str.slice(0,-2)
        return newStr+'00+'
      }
    }else{
      return str
    }
  }
})
Vue.directive('paste',{
  bind(el,binding,vnode) {
    el.addEventListener('paste',function(event){ //这里直接监听元素的粘贴事件
      binding.value(event)
    })
  }
})//复制粘贴指令
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js